import { connect } from 'react-redux';
import { message, Spin, Modal } from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import Spinner from 'react-spinkit';

import MeOverlayLoading from '../../components/MeOverlayLoading';
import MeSpinIcon from '../../components/MeSpinIcon';

import {
    fetchSingleOrder,
    shipOrder
} from '../../actions/Order';

import OrderDetailStatus from './OrderDetailStatus';
import OrderDetailAddress from './OrderDetailAddress';
import OrderDetailPayment from './OrderDetailPayment';

const $ = window.$;

class OrderDetail extends Component {


    constructor(props) {
        super(props);

        this.state = {
            isShipping: false,
            isCanceling: false
        }
    }


    componentDidMount() {
        $("input.shipped").click(function () {
            $(".input-txt").show();
            $('.btn-save .green-btn').removeClass('disable');
            $('.btn-save .green-btn').removeAttr('disabled');
        });
        $("input.cancel").click(function () {
            $(".input-txt").hide();
            $('.btn-save .green-btn').removeClass('disable');
            $('.btn-save .green-btn').removeAttr('disabled');
        });

        const { orders, match, history, location } = this.props;
        const { uid, orderId } = match.params;

        console.log(match);

        if (uid && orderId) {
            this.props.fetchSingleOrder(uid, orderId);
        }

        // const orderObject = this.props.order[]
    }

    // Actions

    onShipOrdePress(trackingNumber) {

        const { orders, match, history, location } = this.props;
        const { uid, orderId } = match.params;

        if (uid && orderId) {

            const order = orders[orderId];

            console.log(trackingNumber);

            this.setState({ isShipping: true });

            // this.props.shipOrder(uid, order.orderId, trackingNumber, (success) => {

            //     console.log(success);
            //     // hide modal
            //     if (success) {

            //         message.success('Notification has been sent to customer.');

            //     } else {
            //         message.error('Error');
            //     }
            // });
        }
    }

    onCancelOrderPress() {


    }

    loadingModal() {
        return (
            <MeOverlayLoading
                visible={this.state.isShipping}
                message={'Saving...'}
            />
        );
    }

    renderLoading() {
        return <Spin indicator={<MeSpinIcon />} />;
    }

/**
 *                 <Spin spinning={this.state.isShipping} indicator={<MeSpinIcon />} >

                </Spin>
 * 
 */

    renderContent(order) {
        return (
            <div className="order-details">
                <div className="order-number">
                    <h3>{`Order #${order.PaymentResponse.tranRef}`}</h3>
                    <p style={{ marginTop: 12, fontSize: 14 }}>{moment(order.createdDate).format('DD MMM YYYY, HH:mm')}</p>
                </div>
                <OrderDetailStatus
                    order={order}
                    onShipOrdePress={this.onShipOrdePress.bind(this)}
                    onCancelOrderPress={this.onCancelOrderPress.bind(this)}
                />
                <div className="ordering-detail">
                    <div className="items">
                        <label>Items</label>
                        <div className="card">
                            <div className="card-body">
                                <div className="card-body-img">
                                    <img src="/resources/img/img-product.png" alt="Product image" />
                                </div>
                                <label>
                                    <span className="item-name" title="Me Nutra - Sesame Oil Me Nutra - Sesame Oil Me Nutra - Sesame Oil">Me Nutra - Sesame Oil Me Nutra - Sesame Oil Me Nutra - Sesame Oil</span>
                                    <br />
                                    <span className="amount">x1</span>
                                    <br />
                                    <span className="price">590.00 ฿</span>
                                    <span className="standard-price">650.00 ฿</span>
                                </label>
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-body">
                                <div className="card-body-img">
                                    <img src="/resources/img/img-product.png" alt="" />
                                </div>
                                <label>
                                    <span className="item-name" title="Me Nutra - Sesame Oil">Me Nutra - Sesame Oil</span>
                                    <br />
                                    <span className="amount">x1</span>
                                    <br />
                                    <span className="price">590.00 ฿</span>
                                    <span className="standard-price">650.00 ฿</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="divider"></div>
                    <OrderDetailAddress order={order} />
                    <div className="divider"></div>
                    <OrderDetailPayment order={order} />
                </div>
                <div className="footer">
                    <div className="row">
                        <div className="col-8"></div>
                        <div className="col">
                            Subtotal
                        </div>
                        <div className="col">
                            1,300.00 ฿
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-8"></div>
                        <div className="col">
                            Discount
                        </div>
                        <div className="col">
                            -120.00 ฿
                        </div>
                    </div>
                    <div className="row grand-total">
                        <div className="col-8"></div>
                        <div className="col">
                            Grand Total
                        </div>
                        <div className="col">
                            1,180.00 ฿
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { orders, match, history, location } = this.props;
        const { uid, orderId } = match.params;

        const order = orders[orderId];

        return (
            <div className="main-content">
                <div className="page-title">Order Details</div>
                <div className="divider"></div>
                {order ? this.renderContent(order) : this.renderLoading()}
                {this.loadingModal()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { orders, isLoading } = state.order;
    return { orders, isLoading };
}

export default connect(mapStateToProps, { fetchSingleOrder, shipOrder })(OrderDetail);


// WEBPACK FOOTER //
// ./src/views/orders/Detail.js